import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Modal, Theme, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { consts } from '../../common/consts'
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { getPasswordStrength, PasswordStrength } from '../../common/utility'
import loginLogo from '../../assets/images/loginLogo.png'
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import api from '../../store/api';
import WelcomeWidget from './WelcomeWidget';
import SignUpVerifyEmailWidget from './SignUpVerifyEmailWidget';
import { useForm, Controller } from "react-hook-form";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Checkbox from '@material-ui/core/Checkbox';
import { useHistory } from "react-router-dom";

interface SignupWidgetProps extends React.Props<any> {
    inviteId: string | null,
    finishSignup(isSuccess: boolean): void
};

const passwordError = "Please enter a stronger password to continue. Try making your password longer, adding special characters (!@#$%^^&*), adding numbers and using upper case letters.";
const termsError = "Indicate your acceptance of our Terms of Service and Privacy Policy to proceed.";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 461,
        background: theme.palette.primary.main,
        borderRadius: 0,

    },
    inputs: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
    },
    labels: {
        marginTop: 30,
        marginLeft: 40,
        marginRight: 40,
        color: 'white'
    },
    button: {
        width: '100%',
        padding: 9,
        borderRadius: 5,
        background: 'white',
        color: theme.palette.primary.main,
        marginBottom: 40,
        fontSize: 'medium'
    },
    link: {
        color: 'whitesmoke',
        marginBottom: 30,
        marginLeft: 40,
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 120
    },
    alertErrorRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 40,
        marginTop: 40
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },
    textFieldInput: {
        backgroundColor: 'rgba(255,255,255, 0.25)',
        color: '#fff',
        borderRadius: '5px',
    },
    terms: {
        marginLeft: '5px',
        color: '#fff'
    }
}));


function SignupWidget(props: SignupWidgetProps): JSX.Element {
    const history = useHistory();
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    const classes = useStyles();
    let passwordWatch = watch('password');
    const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
    const [organisation, setOrganisation] = useState<string>("");
    const [signUpStep, setSignUpStep] = useState(0);
    const [invalidInviteId, setInvalidInviteId] = useState(false);
    const [currentEmailAddress, setCurrentEmailAddress] = useState("");
    const [errorMessagePassword, setErrorMessagePassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [termsCondtions, setTermsCondtions] = useState(false);

    React.useEffect(() => {
        getSignupData();
    }, [props.inviteId])

    const getSignupData = async (): Promise<void> => {
        try {
            const res = await api.getSignup(`inviteId=${props.inviteId}`);
            if (res.data !== null && res.data !== undefined && res.data != "") {
                setCurrentEmailAddress(res.data.emailAddress);
                setOrganisation(res.data.organisation);
                setValue('firstName', res.data.firstName);
                setValue('lastName', res.data.lastName);
                setValue('emailAddress', res.data.emailAddress);
                setValue('phoneNumber', res.data.phoneNumber);

            }
            else {
                setInvalidInviteId(true);
            }
        }
        catch
        {
            setInvalidInviteId(true);
        }
    }



    const singUp = async (data: any): Promise<void> => {
        if (!termsCondtions) {
            setErrorMessage(termsError);
            setErrorMessagePassword(true);
            return;
        }

        let resEmailUnique = await api.validateEmailUniqueDuringSignUp('', {
            inviteId: props.inviteId ?? '',
            emailAddress: data.emailAddress
        });

        if (resEmailUnique.data) {
            data['invitationId'] = props.inviteId ?? '';
            if (currentEmailAddress === data['emailAddress']) {

                try {
                    let res = await api.signup('', data);
                    if (res.status === 200) {
                        setSignUpStep(2);
                    }
                }
                catch
                {

                }
            }
            else {
                const emailChangeReq: { [index: string]: string } = {
                    inviteId: props.inviteId ?? '',
                    emailAddress: data['emailAddress']
                };
                let res = await api.requestEmailChangeDuringSignUp('', emailChangeReq);
                if (res.status === 200) {
                    setSignUpStep(1);
                }

            }
        }
        else {
            setError('emailAddress', { message: "Email Address already exists" });
        }
    }

    const updatePasswordStrengtLabel = () => {
        let fontColor = '#FF806F';
        if (passwordStrength === PasswordStrength.good) {
            fontColor = '#6DE99E';
        }
        else if (passwordStrength === PasswordStrength.moderate) {
            fontColor = '#FFEF4C';
        }
        return (
            <label style={{ color: fontColor }}> {passwordStrength} </label >
        )
    }
    const handOnContinueEmailChange = async (code: string): Promise<void> => {
        let data = getValues();

        data['invitationId'] = props.inviteId ?? '';
        data['EmailConfirmationCode'] = code;

        try {
            let res = await api.signup('', data);
            if (res.status === 200) {
                setSignUpStep(2);
            }
        }
        catch
        {

        }

    }

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);

    const handleClickShowConfirmedPassword = () => {

        setShowConfirmedPassword(!showConfirmedPassword);
    };

    const handleMouseDownConfirmedPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const passwordStrength = getPasswordStrength(e.target.value);
        setPasswordStrength(passwordStrength);
    }

    const clickTermsConditions = () => {
        setTermsCondtions(!termsCondtions);
    }

    const navigateToTermsPage = () => {
        history.push('/login');
    }

    return (
        <React.Fragment>
            <div style={{ display: signUpStep === 0 ? 'block' : 'none' }}>

                <Card className={classes.root}>


                    <div className={classes.logoRoot}>
                        <img src={loginLogo} className={classes.logoImg} alt="logo" />
                    </div>
                    <div style={{ display: invalidInviteId ? 'block' : 'none' }}>
                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                            Your invitation link is invalid
                        </Alert>

                    </div>
                    <div style={{ display: invalidInviteId ? 'none' : 'block' }}>
                        <div className={classes.labels} style={{ fontSize: 36 }}>
                            <label>
                                You've been invited to join SMA Live!
                    </label>
                        </div>
                        <div className={classes.labels} style={{ fontSize: 18 }}>
                            <label>
                                Organisation:
                    </label>
                        </div>
                        <form onSubmit={handleSubmit(singUp)} >
                            <div className={classes.labels} style={{ marginTop: 5, fontWeight: 'bold' }}>
                                <label>
                                    {organisation}
                                </label>
                            </div>
                            <div className={classes.inputs} style={{ marginTop: 30 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Controller
                                            control={control}
                                            defaultValue=''
                                            as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                                placeholder='First Name'
                                                onChange={handlePasswordChange}
                                                error={errors.firstName}
                                                helperText={errors.firstName ? errors.firstName.message : ""} />}
                                            name='firstName'
                                            rules={{
                                                required: "First Name is required",

                                            }}

                                        />

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            control={control}
                                            defaultValue=''
                                            as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                                placeholder='Last Name'
                                                error={errors.lastName}
                                                helperText={errors.lastName ? errors.lastName.message : ""} />}
                                            name='lastName'

                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.inputs}>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined' placeholder='Email Address' error={errors.emailAddress} helperText={errors.emailAddress ? errors.emailAddress.message : ""} />}
                                    name='emailAddress'
                                    rules={{
                                        required: "Email Address is required",
                                        pattern: {
                                            value: consts.EmailRegex,
                                            message: "Invalid email address"
                                        },

                                    }}
                                />
                            </div>
                            <div className={classes.inputs}>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined' placeholder='Phone Number'
                                        error={errors.phoneNumber} helperText={errors.phoneNumber ? errors.phoneNumber.message : ""} />}
                                    name='phoneNumber'
                                    rules={{
                                        required: "Phone Number is required",

                                    }}
                                />
                            </div>
                            <div className={classes.inputs}>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    render={({ onChange, onBlur, value, name }) => (<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                        classes: {
                                            root: classes.textFieldInput
                                        },
                                        endAdornment: <InputAdornment position="end">
                                            <IconButton style={{ color: '#fff' }}
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}>
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }}
                                        onBlur={onBlur}
                                        value={value}
                                        name={name}
                                        onChange={e => {
                                            let pwdStrength = getPasswordStrength(e.target.value);
                                            setPasswordStrength(pwdStrength);
                                            onChange(e)
                                        }}
                                        variant='outlined' placeholder='Password' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />)}
                                    name='password'
                                    rules={{
                                        required: "Password is required",
                                        validate: (value) => {
                                            let pwdStrength = getPasswordStrength(value);
                                            if (pwdStrength !== PasswordStrength.good) {
                                                setErrorMessagePassword(true);
                                                setErrorMessage(passwordError);
                                                return false;
                                            }
                                            else {
                                                setErrorMessagePassword(false);
                                                setErrorMessage("");
                                                return true;
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className={classes.inputs}>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                        classes: {
                                            root: classes.textFieldInput
                                        },
                                        endAdornment: <InputAdornment position="end">
                                            <IconButton style={{ color: '#fff' }}
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowConfirmedPassword}
                                                onMouseDown={handleMouseDownConfirmedPassword}>
                                                {showConfirmedPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }} variant='outlined' placeholder='Confirmed Password' type={showConfirmedPassword ? 'text' : 'password'} error={errors.confirmedPassword} helperText={errors.confirmedPassword ? errors.confirmedPassword.message : ""} />}
                                    name='confirmedPassword'
                                    rules={{
                                        required: "Confirmed Password is required",
                                        validate: (value) => {
                                            if (passwordWatch === value) {
                                                return true;
                                            }
                                            else {
                                                return "Confirmed Password does not match"
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className={classes.labels} style={{ marginTop: 10 }}>
                                <label>Password strength:{' '}</label>
                                {updatePasswordStrengtLabel()}
                            </div>

                            <div style={{ paddingLeft: 30, display: 'flex', flexDirection: 'row' }}>
                                <div>
                                    <Checkbox name="termsandconditions"
                                        style={{ color: 'white', backgroundColor: 'transparent', fill: 'transparent' }}
                                        checked={termsCondtions}
                                        key="termsandconditionscheckbox"
                                        onChange={clickTermsConditions} />
                                </div>
                                <div style={{ color: 'white', paddingTop: 10, marginRight: 40 }}>
                                    I understand that by continuing, I accept the <a style={{ color: 'white' }} target="_blank" href={consts.TermsLink}>Terms of Use </a> and <a style={{ color: 'white' }} target="_blank" href={consts.PrivacyLink}>Privacy Policy</a>
                                </div>
                            </div>

                            {
                                errorMessagePassword ?
                                    <div>
                                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                                            {errorMessage}
                                        </Alert>
                                    </div>
                                    : null
                            }


                            <div className={classes.inputs} style={{ marginTop: 30 }}>
                                <Button
                                    type='submit'
                                    className={classes.button}
                                    disabled={formState.isSubmitting}
                                    variant="contained">Continue</Button>
                            </div>
                        </form>
                    </div>
                </Card>
            </div>
            <div style={{ display: signUpStep === 1 ? 'block' : 'none' }}>
                <SignUpVerifyEmailWidget inviteId={props.inviteId ?? ''} emailAddress={String(getValues('emailAddress'))} handleOnContinue={handOnContinueEmailChange} />
            </div>
            <div style={{ display: signUpStep === 2 ? 'block' : 'none' }}>
                <WelcomeWidget />
            </div>
        </React.Fragment >
    );
}

export default React.memo(SignupWidget) 
